/** DS-CMP-003 — one shared status-color mapping, never redefined per screen. */
const STATUS_COLOR_MAP: Record<string, "green" | "orange" | "red" | "blue" | "gray"> = {
  "In Stock": "green",
  "Low Stock": "orange",
  "Out of Stock": "red",
  Open: "blue",
  "In Progress": "orange",
  Closed: "gray",
  Complete: "green",
  Completed: "green",
  Sent: "green",
  Shipped: "blue",
  "Pending Approval": "orange",
  "Backorder Parts": "red",
  "Not Sent": "gray",
  "Ready to Ship": "blue",
  Received: "green",
  "Not Started": "gray",
  Pass: "green",
  Pending: "gray",
  Fail: "red",
  Approved: "green",
  Rejected: "red",
  "In Picking": "orange",
  "N/A": "gray",
  Confirmed: "red",
  Dismissed: "gray",
  Reviewed: "blue",
};

export function StatusBadge({ status }: { status: string }) {
  const color = STATUS_COLOR_MAP[status] ?? "gray";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-bold bg-status-${color}-bg text-status-${color}`}
    >
      {status}
    </span>
  );
}
